module.exports = __webpack_public_path__ + "img/floor5.b0350587.jpg";